import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GatewayAccountService } from '@tj/tj-dmp-lib-api';
import { MessageService } from 'primeng/api';
import { AccountService } from '../../admin/auth/account.service';

@Component({
    templateUrl: './account-reset-password.component.html',
    styleUrls: ['./account-reset-password.component.scss'],
    standalone: false
})
export class AccountResetPasswordComponent {
	password: string;
	confirm: string;

	hidePassword = true;
	hideConfirm = true;

	colors = ['rgb(185 28 28)', 'rgb(234 88 12)', 'rgb(250 204 21)', 'rgb(16 185 129)', 'rgb(21 128 61)'] as const;

	key: string;

	get strength() {
		if(!this.password || this.password.length === 0) {
			return 0;
		} else if(this.password.length < 8) {
			return this.password.length / 8 * 25;
		} else if(this.password.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/)) {
			return (this.password.length - 8) / 16 * 25 + 75;
		} else if(this.password.match(/((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))/)) {
			return (this.password.length - 8) / 16 * 25 + 50;
		} else {
			return (this.password.length - 8) / 16 * 25 + 25;
		}
	}

	get color() {
		if (this.strength <= 25) {
			return this.colors[0];
		} else if (this.strength <= 50) {
			return this.colors[1];
		} else if (this.strength <= 75) {
			return this.colors[2];
		} else if (this.strength < 90) {
			return this.colors[3];
		} else {
			return this.colors[4];
		}
	}

	constructor(private gatewayAccountService: GatewayAccountService, private route: ActivatedRoute, private messageService: MessageService, private router: Router, private accountService: AccountService) {
		this.key = this.route.snapshot.queryParams.key
	}

	ngOnInit() {
		this.accountService.identity().then((el) => {
			if(el) this.router.navigate(['/h']);
		})
	}

	save() {
		if(this.password !== this.confirm) {
			this.messageService.add({ severity: 'error', summary: 'Erreur', detail: "Les mots de passes sont différents"})
			return;
		}
		this.gatewayAccountService.finishPasswordResetUsingPOST({
			key: this.key,
			newPassword: this.password,
		}, 'events').subscribe(() => {
			this.messageService.add({ severity: 'success', summary: 'Succès', detail: "Votre mot de passe a bien été changé"})
			this.router.navigate(['']);
		}, () => {
			this.messageService.add({ severity: 'error', summary: 'Erreur', detail: "Le mot de passe est incorrect"})
		})
	}
}
